import React, { useState } from 'react'
import { apiGet } from '../../../generic/Api_Functions'
import { useSmartTranslation } from '../../../generic/hooks/useSmartTranslation'
import { DefaultAccordion } from '../../../generic/DefaultAccordion'
import { useSmartInterval } from '../../../generic/hooks/useSmartInterval'
import { Stack, Typography } from '@mui/material'
import ConstructionIcon from '@mui/icons-material/Construction'
import LinkedJobReference from './LinkedJobReference'

/**
* @typedef {import("../../../generic/utilities/objectStructures/toolwindows/FabricationOrder").FabricationOrder} FabricationOrder Fabrication Order object
* @typedef {import("../../../generic/utilities/objectStructures/toolwindows/LinkedJobReference").LinkedJobReference} LinkedJobReference Linked Job Reference object
*/

/**
 * @param {Object} props
 * @param {FabricationOrder} props.fabricationOrder
 * @returns
 */
const FabricationOrder = ({ fabricationOrder }) => {
  const { t_ } = useSmartTranslation()
  /** @type {[LinkedJobReference[],  React.Dispatch<SetStateAction<LinkedJobReference[]>>]} */
  const [linkedJobReferences, setLinkedJobReferences] = useState(null)
  const [expandedAccordion, setExpandedAccordion] = useState(false)

  const linkedJobReferenceInterval = useSmartInterval(
    async () => {
      return await apiGet('toolTable/fabricationOrder/' + fabricationOrder.id + '/linkedJobReferences')
    },
    2000,
    (data) => {
      if (data != null) {
        setLinkedJobReferences(data)
      }
    }, false)

  const getFabricationOrderHeader = () => {
    return (
      <>
        <Stack direction='row' gap={3}>
          <Typography>{t_('FO') + ': ' + fabricationOrder.name}</Typography>
          <Stack direction='row' gap={3}>
            <Typography>{t_('Part Reference') + ': ' + fabricationOrder.partReferenceName}</Typography>
            <Typography>{t_('Total Quantities') + ': ' + fabricationOrder.totalQuantity}</Typography>
            <Typography>{t_('Finished') + ': ' + fabricationOrder.finishedQuantity}</Typography>
            <Typography>{t_('Pending') + ': ' + fabricationOrder.pendingQuantity}</Typography>
            <Typography>{t_('Job Linker') + ': ' + fabricationOrder.partReferenceWorkflowName}</Typography>
            <Typography>{t_('Workflow') + ': ' + fabricationOrder.workflowName}</Typography>
            <Typography>{t_('Client') + ': ' + fabricationOrder.clientName}</Typography>
          </Stack>
        </Stack>
        <Stack>
          <ConstructionIcon color={fabricationOrder.toolOk ? 'primary' : 'error'} />
        </Stack>
      </>
    )
  }

  return (
    <DefaultAccordion
      key={fabricationOrder.id}
      onExpandedStatusChange={(expanded) => {
        if (expanded !== expandedAccordion) {
          linkedJobReferenceInterval(expanded)
          setExpandedAccordion(expanded)
        }
      }}
      headerRender={getFabricationOrderHeader()}
      defaultExpanded={false}
      headerSx={{ backgroundColor: theme => theme.palette.background.paper }}
      contentSx={{ backgroundColor: theme => theme.palette.background.paper }}
    >
      {
expandedAccordion
  ? linkedJobReferences?.map((linkedJobReference) => {
    return (
      <LinkedJobReference
        key={linkedJobReference.id}
        fabricationOrder={fabricationOrder}
        linkedJobReference={linkedJobReference}
      />
    )
  })
  : null
      }
    </DefaultAccordion>
  )
}

export default FabricationOrder
